<ef-loading-container [observables]="[process$, contracts$]"
    [loading]="projectBudgetDataService.loading$ | async"></ef-loading-container>
<ef-process-detail [process]="process$ | async"></ef-process-detail>
<div class="card">
    <div style="display: flex">
        <p-dialog header="Upload Excel File" [(visible)]="showUploadDialog" [maximizable]="false" [closable]="false"
            [closeOnEscape]="false" [style]="{ width: '35vw', height: '47vh' }">
            <div class="grid">
                <div class="col-12">
                    <div class="grid">
                        <span class="col-12">
                            Steps for uploading a budget worksheet:
                        </span>
                        <span class="col-12">
                            1. Download the budget data entry worksheet
                        </span>
                        <span class="col-12">
                            2. Update the worksheet with the budget in Excel
                        </span>
                        <span class="col-12">
                            3. Save the worksheet
                        </span>
                        <span class="col-12">
                            4. Upload the completed Excel worksheet
                        </span>
                        <!-- <span class="col-12">
                        5. Once reviewed, commit the cumulatives to apply them
                    </span> -->
                    </div>

                </div>
                <div class="col-12">
                    <div class="grid flex">
                        <div class="col-12 justify-content-center text-center"
                            style="margin-top: 1em; padding: 2em; border: 2px dashed grey; background-color: #f0f0f0;">
                            <label for="file-upload" class="ef-file-upload">
                                <i class="pi pi-file-excel" style="color: black; padding-right: .25em;"></i>
                                Browse...
                            </label>
                            <span id="file-selected" style="padding-left: 1em"></span>
                            <input #fileUpload id="file-upload" type="file" accept=".xls, .xlsx"
                                (change)="uploadExcelFile($event)">

                            <p-message *ngIf="this.showUploadError" severity="error"
                                text="Please select a file first"></p-message>
                        </div>
                    </div>
                </div>

            </div>

            <ng-template #footer >
                <button type="button" pButton icon="pi pi-upload" (click)="sendJSON()" label="Upload"
                    class="p-button-text p-button-primary"></button>
                <button type="button" pButton (click)="this.showUploadDialog = false;" icon="pi pi-times" label="Cancel"
                    class="p-button-text p-button-danger"></button>
            </ng-template>
        </p-dialog>
    </div>
    <p-toolbar styleClass="mt-2">
        <button pRipple pButton icon="pi pi-external-link" label="Build Worksheet" title="Build Worksheet"
            severity="primary" (click)="openBudgetReport()"></button>
        <button type="button" pButton pRipple icon="pi pi-upload" (click)="showUploadDialog = true" label="Upload"
            severity="primary"></button>
        <p-message severity="info"
            text="Build the eFAACT template spreadsheet and save to Excel.  Enter a monthly budget for each row.  On the upload, eFAACT applies the budget to each month in the selected date range."></p-message>
        <p-message *ngIf="uploadSuccessMessage != null" severity="success" [text]="uploadSuccessMessage"></p-message>
    </p-toolbar>
    <p-accordion [multiple]="true" (activeIndexChange)="handleOnOpen($event)">
        <p-accordionTab [selected]="true" header="Budget Contract Summary">
            <div [ngStyle]="{ height: divScrollHeight }">
                <ef-project-budget-contract [tableScrollHeight]="tableScrollHeight" [items]="contracts$ | async"
                    [BudgetLevels]="budgetLevels$ | async" [BudgetCycles]="budgetCycles$ | async"
                    [contractFilterSelectItems]="contractFilterSelectItems$ | async"
                    [download]="DownloadContractSubject.asObservable() | async" [disabled]="editingBudget"
                    [selectedError]="selectedError$ | async" (BudgetCycleChange)="onBudgetCycleChange($event)"
                    (SelectItem)="onSelectContract($event)" (SaveItem)="
                    onSaveBudgetContract($event); editingContract = false
                " (EditItem)="editingContract = true" (CancelItem)="editingContract = false"
                    (ShowError)="onShowError($event)"></ef-project-budget-contract>
            </div>
        </p-accordionTab>
        <p-accordionTab [selected]="true"
            *efLet="selectContractSubject.asObservable() | async as contract">
            <ng-template #header>
                <span>Budget Detail for {{ contract?.Contractdesc }}</span>
            </ng-template>
            <div [ngStyle]="{ height: detailDivScrollHeight }">
                <ef-project-budget [tableScrollHeight]="detailTableScrollHeight" [items]="projectBudgets$ | async"
                    [directReports]="directReports$ | async" [serviceItems]="serviceItems$ | async"
                    [payrollItems]="payrollItems$ | async" [FYStartDate]="FYStartDate$ | async"
                    [FYEndDate]="FYEndDate$ | async" [BudgetCycle]="BudgetCycleChangeSubject.asObservable() | async"
                    [contract]="contract" [download]="DownloadBudgetSubject.asObservable() | async"
                    [roles]="roles$ | async" [CostCenters]="costCenters$ | async"
                    [loading]="projectBudgetDataService.loading$ | async" [disabled]="editingContract"
                    [allowCost]="allowCost$ | async" [AutoCalculateAmount]="autoCalculateAmount$ | async"
                    [selectedError]="selectedError$ | async" (FiscalYearChange)="onFiscalYearChange($event)"
                    (Add)="onAddBudget($event)" (Save)="onSaveBudget($event); editingBudget = false"
                    (SaveMetadata)="onSaveMetadata($event); editingBudget = false"
                    (SelectPerson)="onSelectPerson($event)" (Edit)="onEditBudgetInit($event)"
                    (Cancel)="onEditBudgetCancel($event)" (Delete)="onDeleteBudget($event)"
                    (Jumpstart)="onJumpstart()" (Download)="onDownload($event)"
                    (UpdateBudget)="onUpdateBudget($event)" (ShowError)="onShowError($event)"></ef-project-budget>
            </div>
        </p-accordionTab>
    </p-accordion>
</div>
